import { TimelineMax, Power2 } from 'gsap/TweenMax'

function heroLogoAnimation() {
  const tl = new TimelineMax()

  tl.delay(0.5)
    .fromTo(
      '.c-hero__lines',
      1,
      { scaleY: 0, xPercent: -50, yPercent: -50, transformOrigin: '50% 50%', autoAlpha: 0 },
      { scaleY: 1, xPercent: -50, yPercent: -50, autoAlpha: 0.5 },
      'bg',
    )
    .add('logo', '-=1')
    .fromTo('.c-hero__logo', 1, { filter: 'blur(20px)' }, { filter: 'blur(0px)' }, 'logo')
    .fromTo(
      '.c-hero__logo-s',
      2,
      { y: -50, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, ease: Power2.easeOut },
      'logo',
    )
    .fromTo(
      '.c-hero__logo-k',
      2,
      { y: 120, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, ease: Power2.easeOut },
      'logo',
    )
    .fromTo(
      '.c-hero__logo-y',
      2,
      { y: -100, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, ease: Power2.easeOut },
      'logo',
    )
    .fromTo(
      '.c-hero__logo-o',
      2,
      { y: 70, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, ease: Power2.easeOut },
      'logo',
    )
    .fromTo(
      '.c-hero__logo-n',
      2,
      { y: -20, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, ease: Power2.easeOut },
      'logo',
    )

  return tl
}

export default heroLogoAnimation
